// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2MMip","actions":"GroupTable_actions__1ZEBg","deleteModalFooter":"GroupTable_deleteModalFooter___9qkB"};